<template>
  <div class="col-md-2 no-padding pr-0">
    <div class="card card-box mb-3 " style="border-radius : 0%; height: 97.5%;">
      <div class="card-body">
        <div class="col-md-12 p-0 text-center mb-3">
          <div class="profile-custom">
            <img :src="imgURL" alt="" srcset="">
            <div class="delete_photo" 
              v-if="(this.imgURL !== '/img/hospital.png' && this.imgURL !== '/img/doctor.png') && imgURL !== null" 
                @mouseover="isDropPhoto = true" 
                @mouseleave="isDropPhoto = false" 
                @click="deletePhoto()">
                <font-awesome-icon class="icon-times" v-show="isDropPhoto"  icon="times"/>
            </div>
          </div>
          <template>
            <picture-input
              style="display:none"
              ref="pictureInput"
              :disabled="btnDisable == true"
              :customStrings="{
                fileSize: 'File maksimal foto 1 mb',
                fileType: 'Jenis file ini tidak didukung'
              }"
              :alertOnError="false"
              :zIndex="1"
              size="2"
              width="130"
              height="125"
              radius="50"
              :hideChangeButton="true"
              @change="onChangeImage($event)"
              :prefill="imgURL"
            />
          </template>
          <div>
            <b-button
              class="__btn_add_photo"
              type="file"
              @click="$refs.pictureInput.onClick()"
              ><font-awesome-icon
                icon="camera"
                class="text-white-50 __icon_add_photo"
            /></b-button>
          </div>
          <br />
          <strong
            style="font-size:14px"
            class="__blue text-left"
            v-if="hasFeatures('dokter') && !hasFeatures('klinik')"
            >Dokter</strong
          >
          <strong
            style="font-size:14px"
            class="__blue text-left"
            v-if="
              hasFeatures('dokter') &&
                hasFeatures('klinik') &&
                this.$route.name == 'account-setting-profile'
            "
            >Dokter</strong
          >
          <h6
            class="mt-2 "
            style="font-size:18px; font-weight: 800; color: gray;"
          >
            <template
              v-if="
                /pic/.test(this.getRolesName) &&
                  this.$route.name != 'account-setting-profile'
              "
            >
              {{ this.dataProfile.nama_klinik }}
            </template>
            <template v-else>
              {{ this.$store.state.user.nama }}
            </template>
          </h6>
          <div
            v-if="
              hasFeatures('klinik') &&
                this.$route.name != 'account-setting-profile'
            "
          >
            <strong style="font-size:12px;" class="__blue text-left">
              {{ optionKlinik }}
            </strong>
          </div>
        </div>
        <br />
        <template v-if="hasFeatures('klinik')">
          <hr style="margin-top:2px;margin-bottom:2px" />
          <div
            class="col-md-12 p-2 text-left _outer_klinik_profile"
            @click="goToKlinik()"
          >
            <strong
              :class="
                this.$route.name == 'account-setting'
                  ? '__blue text-left'
                  : 'text-left'
              "
              @click="goToKlinik()"
              style="font-size:12px"
              >Informasi Klinik</strong
            >
          </div>
        </template>
        <template v-if="hasFeatures('dokter')">
          <hr style="margin-top:2px;margin-bottom:2px" />
          <div
            class="col-md-12 p-2 text-left _outer_klinik_profile"
            @click="goToProfile()"
          >
            <strong
              style="font-size:12px"
              :class="
                this.$route.name == 'account-setting-profile' ? '__blue' : ''
              "
              @click="goToProfile()"
              >Data Profil</strong
            >
          </div>
        </template>
        <hr style="margin-top:2px;margin-bottom:2px" />
        <div
          class="col-md-12 p-2 text-left _outer_klinik_profile"
          @click="goToJadwal()"
        >
          <strong
            style="font-size:12px"
            @click="goToJadwal()"
            :class="
              this.$route.name == 'account-setting-fasilitas'
                ? '__blue text-left'
                : 'text-left'
            "
            >Jadwal & Fasilitas</strong
          >
        </div>
        <template v-if="hasFeatures('klinik')">
          <hr style="margin-top:2px;margin-bottom:2px" />
          <div
            class="col-md-12 p-2 text-left _outer_klinik_profile"
            @click="goToSkemaKomisi()"
          >
            <strong
              style="font-size:12px"
              @click="goToSkemaKomisi()"
              :class="
                this.$route.name == 'account-setting-skema-komisi'
                  ? '__blue text-left'
                  : 'text-left'
              "
              >Skema Komisi</strong
            >
          </div>
        </template>
        <template v-if="hasFeatures('klinik')">
          <hr style="margin-top:2px;margin-bottom:2px" />
          <div
            class="col-md-12 p-2 text-left _outer_klinik_profile"
            @click="goToBridgingBPJS()"
          >
            <strong
              style="font-size:12px"
              @click="goToBridgingBPJS()"
              :class="
                this.$route.name == 'account-setting-bridging-bpjs'
                  ? '__blue text-left'
                  : 'text-left'
              "
              >Bridging BPJS</strong
            >
          </div>
        </template>
        <template v-if="hasFeatures('klinik')">
          <hr style="margin-top:2px;margin-bottom:2px" />
          <div
            class="col-md-12 p-2 text-left _outer_klinik_profile"
            @click="goToBridgingSatuSehat()"
          >
            <strong
              style="font-size:12px"
              @click="goToBridgingSatuSehat()"
              :class="
                this.$route.name == 'account-setting-bridging-satu-sehat'
                  ? '__blue text-left'
                  : 'text-left'
              "
              >Integrasi Satu Sehat</strong
            >
          </div>
        </template>
        <template v-if="hasFeatures('klinik')">
          <hr style="margin-top:2px;margin-bottom:2px" />
          <div
            class="col-md-12 p-2 text-left _outer_klinik_profile"
            @click="goToSettingLocation()"
          >
            <strong
              style="font-size:12px"
              @click="goToSettingLocation()"
              :class="
                this.$route.name == 'account-setting-setting-location'
                  ? '__blue text-left'
                  : 'text-left'
              "
              >Lokasi</strong
            >
          </div>
        </template>
        <hr style="margin-top:2px;margin-bottom:2px" />
      </div>
    </div>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfo, faFolder, faCamera, faTimes } from "@fortawesome/free-solid-svg-icons";
library.add(faInfo, faCamera, faFolder, faTimes);
import { EventBus } from "../../event-bus";

export default {
  components: {
    PictureInput
  },
  data() {
    return {
      isDropPhoto: false,
      dataProfile: [],
      btnDisable: true,
      imgURL: "",
      isDefault: true,
      optionKlinik: null
    };
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"])
  },
  mounted() {
    this.getProfile();

    if (this.$refs.pictureInput.file != undefined) {
      this.isDefault = false;
    }
  },

  methods: {
    async getProfile() {
      try {
        let profile;
        this.imgURL = "";

        if (
          this.hasFeatures("rangkap") &&
          this.$route.name == "account-setting-profile"
        ) {
          //dokter & pic

          profile = this.$store.state.user.id;
          const res = await this.$axios.get(
            `klinik/dokter/${profile}?klinik_id=${this.getKlinikId}&profile=true`
          );

          const { data } = res.data;
          if (data.foto_dokter == null) {
            this.imgURL = "/img/doctor.png";
          } else {
            this.imgURL = data.foto_dokter;
          }
        } else if (/pic/.test(this.getRolesName)) {
          //pic
          this.$store.state.klinikUser.map(data => {
            if (data.parent_id != null && data.id == this.getKlinikId) {
              profile = data.parent_id;
            }
          });

          const res = await this.$axios.get(
            `klinik/${this.getKlinikId}?klinik_id=${profile}&profile=true`
          );

          const { data } = res.data;

          if (data.foto_klinik == null) {
            this.imgURL = "/img/hospital.png";
          } else {
            this.imgURL = data.foto_klinik;
          }

          this.optionKlinik = data.tipe_faskes;
          this.dataProfile = data;
        } else {
          //dokter

          profile = this.$store.state.user.id;
          const res = await this.$axios.get(
            `klinik/dokter/${profile}?klinik_id=${this.getKlinikId}&profile=true`
          );

          const { data } = res.data;
          if (data.foto_dokter == null) {
            this.imgURL = "/img/doctor.png";
          } else {
            this.imgURL = data.foto_dokter;
          }
        }
      } catch (error) {}
    },
    hasFeatures(value) {
      const features = {
        klinik: ["pic_cabang", "pic_pusat"],
        dokter: ["dokter_klinik"],
        rangkap: ["pic_cabang", "pic_pusat", "dokter_klinik"]
      };
      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    goToKlinik() {
      this.$router.push({ name: "account-setting" });
    },
    goToJadwal() {
      this.$router.push({ name: "account-setting-fasilitas" });
    },
    goToProfile() {
      this.$router.push({ name: "account-setting-profile" });
    },
    goToSkemaKomisi() {
      this.$router.push({ name: "account-setting-skema-komisi" });
    },
    goToBridgingBPJS() {
      this.$router.push({ name: "account-setting-bridging-bpjs" });
    },
    goToBridgingSatuSehat() {
      this.$router.push({ name: "account-setting-bridging-satu-sehat" });
    },
    goToSettingLocation() {
      this.$router.push({ name: "account-setting-setting-location" });
    },
    onChangeImage(image) {
      let formData = new FormData();

      let size = this.$refs.pictureInput.file.size;
      if (size >= 1111258) {
        this.$swal({
          type: "warning",
          text:
            "Hanya dapat memasukkan format JPEG, JPG, PNG maks. ukuran 1 MB!"
        });
        this.$refs.pictureInput.file = null;
        this.$refs.pictureInput.image = null;
        this.$refs.pictureInput.fileModified = null;
        this.$refs.pictureInput.fileName = null;
        this.$refs.pictureInput.fileSize = null;
        this.$refs.pictureInput.fileType = null;
        return;
      } else {
        formData.append("klinik_id", this.getKlinikId);
        formData.append("file", this.$refs.pictureInput.file);
      }

      if (image) {
        let profile;

        if (
          this.hasFeatures("rangkap") &&
          this.$route.name == "account-setting-profile"
        ) {
          profile = this.$store.state.dokterId;
          formData.append("type", "dokter");
        } else if (/pic/.test(this.getRolesName)) {
          profile = this.getKlinikId;
          formData.append("type", "klinik");
        } else {
          formData.append("type", "dokter");
          profile = this.$store.state.dokterId;
        }

        this.$axios
          .post(`klinik/upload/photo/${profile}`, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then((respononse) => {
            this.imgURL = respononse.data.data.url;
            this.isDropPhoto = false;
            EventBus.$emit("image-uploaded", true);
          });
      }
    },
    deletePhoto() {
      try {
        let formData = new FormData(),
          profile;

        if (
          this.hasFeatures("rangkap") &&
          this.$route.name == "account-setting-profile"
        ) {
          profile = this.$store.state.dokterId;
          formData.append("type", "dokter");
        } else if (/pic/.test(this.getRolesName)) {
          profile = this.getKlinikId;
          formData.append("type", "klinik");
        } else {
          formData.append("type", "dokter");
          profile = this.$store.state.dokterId;
        }

        this.$axios
          .post(`klinik/delete-photo/${profile}`, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(() => {
            if (
                this.hasFeatures("rangkap") &&
                this.$route.name == "account-setting-profile"
              ) {
                this.imgURL = "/img/doctor.png";
              } else if (/pic/.test(this.getRolesName)) {
                this.imgURL = "/img/hospital.png";
              } else {
                this.imgURL = "/img/doctor.png";
              }
            EventBus.$emit("image-uploaded", true);
          });
      } catch (error) {
        // console.log(error)
      }
    }
  }
};
</script>

<style>
.picture-inner {
  top: -120px !important;
}
</style>

<style scoped>
.__blue {
  color: #4b80b6;
}

._outer_klinik_profile {
  cursor: pointer;
}

.__outer_line_profile {
  border-right: rgb(121, 121, 121);
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-right-style: solid;
}

.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: 15px;
  z-index: 20;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}

.delete_photo {
    position: absolute;
    width: 100%;
    height: 20%;
    top: 30%;
    z-index: 9;
    font-size: 30pt;
    text-align: center;
}


.icon-times {
    background-color: #f2fefa;
    border-radius: 50%;
    padding: 6px;
    width: 40px;
    height: 40px;
}

.profile-custom {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #cdcdcd;
}

.profile-custom img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
</style>
